<template>
    <div
        :class="state.isOpen === file.name? 'bg-gray-tier-5':''"
        :title="file.name"
        class="hover:bg-gray-tier-5 group w-full flex items-center p-2 justify-between"
    >
        <span class="flex items-center gap-3 flex-1">
            <span
                v-if="groupType == 'Key Resources' && file.tags?.[0]?.name"
                class="font-medium text-xs rounded-md px-3 text-white inline-block text-center w-24 mr-2 shrink-0"
                :class="keyColors[file.tags[0].name]"
            >
                {{ file.tags[0].name }}
            </span>
            <BaseSvg v-else 
                :name="getIcon(file.name)"
                class="w-5 h-auto fill-secondary shrink-0" />
            <button
                @click.stop.prevent="getResource($event, file)"
                class="flex items-center text-left gap-8 text-sm w-full hover:underline underline-offset-4 decoration-1"
            >
                <span class="whitespace-nowrap">{{file.name}}</span>
            </button>
        </span>
        <span class="relative w-fit pr-2">
            <button
                class="opacity-0 group-hover:opacity-50 active:!opacity-100 hover:!opacity-100"
                :class="state.isOpen === file.name ?'!opacity-100':''"
                @click="state.isOpen === file.name ? state.isOpen = false: state.isOpen = file.name"
            >
                <BaseSvg name="icon-more-horiz" />
            </button>
            <Transition name="search-pop">
                <ActionDropdown
                    v-click-outside="close"
                    v-if="state.isOpen === file.name "
                    :offset="{right:0}"
                    :options="options"
                />
            </Transition>
        </span>

<!--            <span class="flex justify-end items-center gap-2">-->
<!--                <Pin-->
<!--                    :id="file?.id"-->
<!--                    type="resource"-->
<!--                    :rotate="true"-->
<!--                />-->
<!--                <AppButton-->
<!--                    v-if="file.asset.source === 3"-->
<!--                    @click="forceDownload($event, marketingAssetUrl(file.asset.external_id), _.kebabCase(file.name)+'.pdf')"-->
<!--                    :icon-only="true"-->
<!--                    icon="file-download"-->
<!--                />-->
<!--            </span>-->
    </div>
</template>

<script setup>
import {BaseSvg, ActionDropdown, Pin} from "@/Components";
import {useAssetTransforms, useResources, useDownload, usePinsDrawer} from "@/Composables";
import {reactive} from "vue";
import _ from 'lodash';

const keyColors = {
    'Price Books': 'bg-project-blue',
    'Catalogs': 'bg-project-gray',
    'Parts': 'bg-project-orange',
    'Parts Lists': 'bg-project-orange',
    'Cut Sheets': 'bg-project-avocado',
    'Videos': 'bg-project-lavender',
}

const props = defineProps({
    file: Object,
    groupType: {
        type: String,
        default: ''
    },
});
const emits = defineEmits(['openOptions'])
const { getResource } = useResources();
const { forceDownload } = useDownload();
const { marketingAssetUrl } = useAssetTransforms();
const { fetchPin, togglePin, removePin, openDrawerTray } = usePinsDrawer();

// const pinComponent = Pin;

const state = reactive({
    isOpen: false,
});

const close = () => state.isOpen = false;

const options = [
    [
        {
            icon: 'file-download',
            label: 'Download',
            action: (event) => forceDownload(event, marketingAssetUrl(props.file.asset.external_id), _.kebabCase(props.file.name)+'.pdf')
        },
        {
            icon: 'push-pin-outlined',
            label: 'Pin this resource',
            action: () => {
                togglePin('resource', props?.file.id);
                close();
            }
        },
    ],
];

function getIcon(type) {
    if (type.toLowerCase().includes('video')) {
        return 'icon-movie';
    }
    return 'icon-draft-paper';
}
</script>
